import views from './views';
import selectors from './selectors';
// eslint-disable-next-line import/no-cycle
import Terms from './terms';
// eslint-disable-next-line import/no-cycle
import Survey from './survey';

class GDPR {
  renderTermOptions = (currentPage) => {
    const termsOptions = {
      elem: selectors.termsLink,
      moveBackBtn: $(selectors.moveBackBtn),
      currentPage: views.basic.terms,
      mainContent: $(selectors.mainContent),
      prevPage: currentPage,
      take_survey_btn_text: 'Back to GDPR',
    };

    new Terms(termsOptions).render();
  };

  constructor(options) {
    const { getText } = Pollfish.ui;
    this.currentPage = options.currentPage;
    this.prevPage = options.prevPage;
    this.onSuccess = options.onSuccess || function onSuccess() {};
    this.isOfferwallDemographics = options.isOfferwallDemographics;
    this.goToOfferwall = options.goToOfferwall;

    this.templ = `
      <div id="data" class="terms-and-conditions gdpr">
        <div class="gdpr__content">
          <h1>${getText('gdpr.heading')}</h1>
          <section>
            <h2>${getText('gdpr.what_data_header')}</h2>
            <ul class="margin-sm">
              <li>${getText('gdpr.what_data_option_one')}</li>
              <li>${getText('gdpr.what_data_option_two')}</li>
              <li>${getText('gdpr.what_data_option_three')}</li>
              <li>${getText('gdpr.what_data_option_four')}</li>
            </ul>
            <p class="margin-reset">${getText('gdpr.what_data_text')}</p>
          </section>
          <section>
            <h2>${getText('gdpr.with_whom')}</h2>
            <ul class="margin-sm">
              <li>${getText('gdpr.with_whom_option_one')}</li>
              <li>${getText('gdpr.with_whom_option_two')}</li>
              <li>${getText('gdpr.with_whom_option_three')}</li>
              <li>${getText('gdpr.with_whom_option_four')}</li>
            </ul>
            <p class="margin-reset">${getText('gdpr.with_whom_text')}</p>
          </section>
          <section>
            <h2>${getText('gdpr.managing_data_header')}</h2>
            <p class="margin-reset">${getText(
              'gdpr.managing_data_list_title',
            )}</p>
            <ul class="margin-sm">
              <li>
                ${getText('gdpr.managing_data_option_one').replace(
                  /(https?:\/\/[^\s]+)/,
                  '<button type="button" class="btn-link btn-link-inline js-open-website" data-url="$1">$1</button>',
                )}
              </li>
              <li>
                ${getText('gdpr.managing_data_option_two').replace(
                  /(https?:\/\/[^\s]+)/,
                  '<button type="button" class="btn-link btn-link-inline js-open-website" data-url="$1">$1</button>',
                )}
              </li>
            </ul>
            <div class="divider"></div>
            <ul class="margin-sm" style="padding-left: 14px;">
              <li>${getText('gdpr.processed_data_option_one')}</li>
              <li>${getText('gdpr.processed_data_option_two')}</li>
              <li>${getText('gdpr.processed_data_option_three')}</li>
            </ul>
          </section>
          <p>
            ${getText('gdpr.privacy_policy').replace(
              /(https?:\/\/[^\s]+)/,
              '<button type="button" class="btn-link btn-link-inline js-open-website" data-url="$1">$1</button>',
            )}
          </p>
          <footer class="gdpr-footer gdpr-footer--inner">
            <div class="gdpr-btn-container">
              <h1 class="js-gdpr-footer">${getText('gdpr.footer')}</h1>
              <a href="#" id="agree-to-gdpr" class="btn btn-primary btn-lg js-agree-to-gdpr">${getText(
                'gdpr.i_agree',
              )}</a>
              <a href="#" id="decline-gdpr" class="js-decline-gdpr btn-link">${getText(
                'gdpr.i_will_not_participate',
              )}</a>
            </div>
          </footer>
        </div>
      </div>`;
  }

  render() {
    const {
      currentPage,
      templ,
      onSuccess,
      isOfferwallDemographics,
      goToOfferwall,
    } = this;
    // const type = 'basic';

    const { getText } = Pollfish.ui;
    // send event that the user has seen the gdpr page
    // Pollfish.analytics.sendEvent('general', 'showGDPR', 'Show GDPR', 1100);

    Pollfish.ui.applyMainContentTemplate(templ);

    // NOTE: the gdpr container exists in two places. The fixed container that exists outside
    //       the .main-content and the gdpr container existing within the main-content.
    //       The former needed to be outside the main-content for issues regarding fixed positioning
    //       while the latter remained inside for when we need a non-fixed to bottom element.
    //       The container existing outside the main-content container, needs to be updated manually
    $('.js-gdpr-footer').text(getText('gdpr.footer'));
    $('.js-agree-to-gdpr').text(getText('gdpr.i_agree'));
    $('.js-decline-gdpr').text(getText('gdpr.i_will_not_participate'));

    // display gdpr
    Pollfish.ui.displayGDPR();
    this.renderTermOptions(currentPage);

    // NOTE: Known bug regarding 'tap' event.
    //      https://stackoverflow.com/questions/10794181/jquery-mobile-tap-event-triggered-for-twice
    //      stopImmediatePropagation is used so that the event doesn't get called twice.
    //      Also, the 'click' event has been optimised for mobile and is therefore the same as using
    //      'tap'. We could update it in the future.
    $('body').on('tap', '.js-agree-to-gdpr', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      Pollfish.store.setIsPreviousPageGDPR(true);
      // Pollfish.analytics.sendEvent('general', 'agreedToGDPR', 'Agreed to GDPR', 1100);
      Pollfish.mobile.interface.sendToServer(
        '/v2/device/termsandconditions/accept',
        `{"s_id": "${Pollfish.helper.json.s_id}"}`,
        false,
      );

      Pollfish.helper.setAcceptedTerms(true);

      if (goToOfferwall) {
        Pollfish.ui.showOfferwall('offerwall-offers');
        return;
      }

      if (isOfferwallDemographics) {
        Pollfish.survey = new Survey({
          ...Pollfish.helper.json.tag_survey,
          isOfferwallDemographics,
        });
      } else {
        Pollfish.survey = new Survey({
          ...Pollfish.helper.json,
          isOfferwallDemographics,
        });
      }

      Pollfish.survey.start().catch(Pollfish.helper.handleError);
    });

    $('body').on('tap', '.js-decline-gdpr', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      Pollfish.store.setSelectedOffer(null);
      Pollfish.store.setIsPreviousPageGDPR(true);
      Pollfish.analytics.sendEvent(
        'general',
        'closeFromGDPR',
        'Declined GDPR',
        1100,
      );
      Pollfish.mobile.interface.sendToServer(
        '/v2/device/termsandconditions/reject',
        `{"s_id": "${Pollfish.helper.json.s_id}"}`,
        false,
      );
      onSuccess();
      Pollfish.mobile.interface.userRejectedSurvey();
      Pollfish.mobile.interface.closeAndNoShow();

      if (currentPage === 'gdpr' && Pollfish.helper.isOfferwall()) {
        Pollfish.store.setSelectedOffer(null);
        Pollfish.ui.showOfferwall(goToOfferwall ? 'offerwall-offers' : '');
      } else if (currentPage === 'gdpr') {
        Pollfish.helper.initSingleSurvey();
      }
    });

    $('body').on('tap', '.js-open-website', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();

      const url = $(e.target).attr('data-url');

      Pollfish.mobile.interface.openWebsite(url);
    });

    setTimeout(() => {
      $('html, body').scrollTop(0);
    }, 0);
  }

  renderShort() {
    const { templ, onSuccess } = this;
    const type = 'playful';

    // display gdpr
    Pollfish.ui.displayGDPR();

    // render presentation container
    $('#gdpr').html(templ);

    $('body').on('tap', '.js-agree-to-gdpr', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      // Pollfish.analytics.sendEvent('general', 'agreedToGDPR', 'Agreed to GDPR', 1100);
      Pollfish.mobile.interface.sendToServer(
        '/v2/device/termsandconditions/accept',
        `{"s_id": "${Pollfish.helper.json.s_id}"}`,
        false,
      );
      onSuccess();
      $('#gdpr').hide();
      $('body').attr('data-page', type);
    });

    $('body').on('tap', '.js-decline-gdpr', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      Pollfish.analytics.sendEvent(
        'general',
        'closeFromGDPR',
        'Declined GDPR',
        1100,
      );
      Pollfish.mobile.interface.sendToServer(
        '/v2/device/termsandconditions/reject',
        `{"s_id": "${Pollfish.helper.json.s_id}"}`,
        false,
      );
      Pollfish.mobile.interface.userRejectedSurvey();
      Pollfish.mobile.interface.closeAndNoShow();
    });
  }
}

export default GDPR;
